import './styles.scss';
import React, {useEffect} from 'react';
import {Redirect, Switch, withRouter, RouteComponentProps} from "react-router-dom";
import {Layout} from "antd";
import cx from 'classnames';
import axios from 'axios';
import {useAuth0} from "@auth0/auth0-react";
import {AppRoutesRenders} from "../../routes/RoutesRegister";
import {BrowserRoutes} from '../../routes/BrowserRouter';
import AppSidebar from "../../components/specific/Sidebar/Sidebar.app";
import AppHeader from "../../components/specific/Header/Header.app";
import useAppStore from "../../data/App.store";
import useUserStore from "../../data/User.store";
import UserApi from "../../api/User/User.api";
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";
import UsersAcceptInvitation from "../../components/specific/Users.acceptInvitation/Users.acceptInvitation";
import {EAccountStatus} from "../../api/User/User.types";
import {ROLES} from "../../settings";

const {Content} = Layout;

interface Props extends RouteComponentProps {
    sidebar?: boolean,
    header?: boolean,
}

function Protected({sidebar, header}: Props) {
    const {getAccessTokenSilently, logout, user} = useAuth0();
    const {setUser, setLoadingUser, loadingUser, user:storeUser} = useUserStore();
    const sidebarCollapsed = useAppStore(state => state.sidebarCollapsed);

    async function initUser() {
        setLoadingUser(true)
        const authToken = await getAccessTokenSilently();
        try {

            // user must be created in backend first
            const authenticatedUser = await UserApi.getMe(authToken);
            axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
            setUser({...authenticatedUser, picture: user?.picture});

        } catch (e) {
            console.log('error', e.message)

            // access token is invalid/timed out/something went wrong setting up user
            logout();
        }
        setLoadingUser(false)
    }

    useEffect(() => {
        initUser();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (loadingUser || !storeUser){
        return (
            <div className='default-loader-full' style={{height:'100vh'}}>
                <DefaultLoader text='Loading user...'/>
            </div>
        )
    }

    if (storeUser.account_status === EAccountStatus.INVITATION_SENT && storeUser.role.name === ROLES.CLIENT){
        return (
            <Layout className='protected with-invitation'>
                {header && <AppHeader/>}
                <div className='user-accept-invitation-container'>
                    <UsersAcceptInvitation/>
                </div>
            </Layout>
        )
    }

    return (
        <Layout className='protected'>
            {header && <AppHeader/>}
            <Layout className={cx('layout', {sidebar, collapsed: sidebarCollapsed})} style={{ marginTop: 64 }}>
                {sidebar && <AppSidebar/>}
                <Content className='app-content' style={{marginLeft: 250}}>
                    <Switch>
                        {AppRoutesRenders}
                        {storeUser.role.name === ROLES.CLIENT ? <Redirect to={BrowserRoutes.dashboard}/> : <Redirect to={BrowserRoutes.users}/>}
                    </Switch>
                </Content>
            </Layout>
        </Layout>
    )
}

export default withRouter(Protected);
